export interface ConfigSettings {
    datafileUrl: string;
    iconsUrl: string;
    brandAssets: {
        logoImage: string;
        css: string;
    };
    sentryUrl: string;
    timeout: number;
    startNotificationUrl: string;
    postForwardNotificationUrl: string;
    getProcessesUrl: string;
    getComponentsUrl: string;
    getCitiesUrl: string;
    getStreetsInCityUrl: string;
    getStreetNumbersInStreetUrl: string;
    getInfoUrl: string;
    uploadImageUrl: string;
    setNotificationReadyUrl: string;
    yarowaFrontentDefaultUrl: string;
    systemHealthUrl: string;
    canForwardToThirdPartyUrl: string;
    supportedThirdPartyForwardingTypesUrl: string;
    graphqlUrl: string;
    graphqlWssUrl: string;
    isMaintenanceActive: boolean;

    // cidaas
    environment: string;

    wwEasyContactClientId: string;
    wwEasyContactClientSecret: string;
    wwEasyContactClientUsername: string;
    wwEasyContactClientPassword: string;

    wwEasyContactPasswordClientId: string;

    cidaasBaseUrl: string;
    cidaasGenerateRequestIdRessource: string;
    cidaasLoginUserRessource: string;
    cidaasGetTokenRessource: string;

    cidaasEndSessionRessource: string;
}
const host = window.location.host;
const isLocal = host.indexOf("localhost") === 0;
let defaultEnv = "prod";

const proxy = isLocal ? "https://dev.wwportal.ch" : `${window.location.protocol}//${host}`;

const apiBaseUrl = `${proxy}/api`;
const restApiBaseUrl = `${apiBaseUrl}/rest`;
const ecBaseUrl = `${proxy}/api/ec`;

export const NetworkConfig = {
    datafileUrl: `${apiBaseUrl}/files/filec/`,
    iconsUrl: isLocal ? "/ec/icons" : `${proxy}/ec/icons`,
    brandAssets: {
        logoImage: `${apiBaseUrl}/designs/logo/brand.jpg`,
        css: `${apiBaseUrl}/designs/css/brand.css`
    },
    sentryUrl: "https://3c297e2a9c654c8796578f31509a4bd4@o421140.ingest.sentry.io/5998175",
    postForwardNotificationUrl: `${ecBaseUrl}/forwardnotification`,
    startNotificationUrl: `${ecBaseUrl}/startnotification`,
    getProcessesUrl: `${restApiBaseUrl}/ec/processes`,
    getComponentsUrl: `${restApiBaseUrl}/ec/components`,
    getCitiesUrl: `${restApiBaseUrl}/common/cities`,
    getInfoUrl: `${ecBaseUrl}/info`,
    canForwardToThirdPartyUrl: `${ecBaseUrl}/canforwardtothirdparty`,
    supportedThirdPartyForwardingTypesUrl: `${ecBaseUrl}/supportedthirdpartyforwardingtypes`,
    getStreetsInCityUrl: `${restApiBaseUrl}/common/streets`,
    getStreetNumbersInStreetUrl: `${restApiBaseUrl}/common/streetnumbers`,
    uploadImageUrl: `${ecBaseUrl}/uploadimage`,
    setNotificationReadyUrl: `${ecBaseUrl}/setready`,
    yarowaFrontentDefaultUrl: "https://enable.jarowa.ch",
    systemHealthUrl: `${apiBaseUrl}/health`,
    graphqlUrl: `${apiBaseUrl}/graphql`,
    graphqlWssUrl: `wss://ww-${defaultEnv}-hasura-wa.azurewebsites.net/v1/graphql`,
    cidaasBaseUrl: "<placeholder>",
    cidaasGenerateRequestIdRessource: "/authz-srv/authrequest/authz/generate",
    cidaasLoginUserRessource: "/login-srv/login/sdk",
    cidaasGetTokenRessource: "/token-srv/token",
    cidaasEndSessionRessource: "/session/end_session",
    wwEasyContactClientId: "<placeholder>",
    wwEasyContactClientSecret: "<placeholder>",
    wwEasyContactClientUsername: "<placeholder>",
    wwEasyContactClientPassword: "<placeholder>",
    wwEasyContactPasswordClientId: "<placeholder>",
    isMaintenanceActive: false
} as ConfigSettings;
